import { useEffect, useState } from "react";
import { DEBUG, debugState, detectWebGL, isIOS, isSafari } from "@/lib/webgl";
import { scrollStore } from "@/lib/scrollStore";

// Read-only diagnostics panel. Renders only with ?debug3d=1. Modifies nothing.
export default function DebugPanel() {
    const [, force] = useState(0);
    const [caps] = useState(() => (DEBUG ? detectWebGL() : { webgl: false, webgl2: false }));
    useEffect(() => {
        if (!DEBUG) return undefined;
        const id = setInterval(() => force((v) => v + 1), 500);
        return () => clearInterval(id);
    }, []);
    if (!DEBUG) return null;
    const canvas = document.querySelector('[data-testid="product-stage"] canvas');
    const rect = canvas ? canvas.getBoundingClientRect() : { width: 0, height: 0 };
    const row = (k, v) => (
        <div key={k} style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
            <span style={{ opacity: 0.55 }}>{k}</span>
            <span style={{ color: typeof v === "boolean" ? (v ? "#4ade80" : "#f87171") : "#4ade80" }}>{String(v)}</span>
        </div>
    );
    return (
        <div
            data-testid="debug3d-panel"
            style={{
                position: "fixed",
                left: 8,
                bottom: 8,
                zIndex: 9999,
                background: "rgba(0,0,0,0.88)",
                color: "#4ade80",
                fontFamily: "monospace",
                fontSize: 10,
                lineHeight: 1.6,
                padding: "10px 12px",
                borderRadius: 10,
                width: 250,
                pointerEvents: "none",
            }}
        >
            <div style={{ color: "#fff", fontWeight: 700, marginBottom: 4 }}>DEBUG 3D (solo lectura)</div>
            {row("iOS detectado", isIOS())}
            {row("Safari detectado", isSafari())}
            {row("viewport", `${window.innerWidth}x${window.innerHeight}`)}
            {row("visualViewport h", window.visualViewport ? Math.round(window.visualViewport.height) : "-")}
            {row("DPR", window.devicePixelRatio)}
            {row("canvas w/h", `${Math.round(rect.width)}x${Math.round(rect.height)}`)}
            {row("model scale", debugState.modelScale ? debugState.modelScale.toFixed(2) : "-")}
            {row("camera Z", "8.8")}
            {row("scroll hero/exp", `${scrollStore.hero.toFixed(2)}/${scrollStore.exp.toFixed(2)}`)}
            {row("WebGL2", caps.webgl2)}
            {row("WebGL1", caps.webgl)}
            {row("renderer mounted", !!canvas)}
        </div>
    );
}
